import { api } from '@common';
import { useQuery } from '@tanstack/react-query';

export interface CustomerDetail {
  id: string;
  defaultMember: {
    name: string;
    cpf: string;
    birthday: string;
    profession?: string;
    monthlyIncome?: string;
  };
  office: {
    id: string;
    name: string;
    avatar?: string;
    cnpj?: string;
    phone?: string;
  };
  advisors: {
    avatar?: string;
    name: string;
    email: string;
    phone?: string;
  }[];
  patrimonyTotal?: number;
  notes?: string;
  lastUpdatedNotes?: string;
}

export const useSingleCustomer = (customerId: string) =>
  useQuery<CustomerDetail>({
    queryKey: ['customer', 'detail', customerId],
    queryFn: () =>
      api
        .get(`/customer/${customerId}`)
        .then((res) => res.data),
    enabled: !!customerId,
    refetchOnWindowFocus: false
  }); 